module.exports = __webpack_public_path__ + "static/img/200191.e39b1e59.png";